import { ListGroup } from "react-bootstrap";

import { certificates } from "../Data";

const Certificates = () => {
	return (
		<ListGroup as="ol" numbered>
			{certificates.map((cert) => (
				<ListGroup.Item
					key={cert.credential}
					className="mb-1 d-flex justify-content-between align-items-start"
					as="li"
				>
					<div className="ms-2 me-auto">
						<div className="fw-bold">
							<a
								href={cert.url}
								target="_blank"
								rel="noopener noreferrer"
							>
								{cert.label}
							</a>
						</div>
						<b>Issued - {cert.date}</b>
						<br />
						<small>
							<span className="d-none d-sm-inline">Credential : </span>
							<i>{cert.credential}</i>
						</small>
					</div>					
					{cert.org === "Google" && (
						<b style={{ color: "red" }}>{cert.org}</b>
					)}
					{cert.org === "IBM" && (
						<b style={{ color: "blue" }}>{cert.org}</b>
					)}
					{cert.org === "Coursera" && (
						<b style={{ color: "orange" }}>{cert.org}</b>
					)}
					{cert.org === "Udemy" && (
						<b style={{ color: "purple" }}>{cert.org}</b>
					)}
				</ListGroup.Item>
			))}
		</ListGroup>
	);
};

export default Certificates;
